import { render, staticRenderFns } from "./ModuleBrandListing.vue?vue&type=template&id=581fb096"
import script from "./ModuleBrandListing.vue?vue&type=script&lang=js"
export * from "./ModuleBrandListing.vue?vue&type=script&lang=js"
import style0 from "./ModuleBrandListing.vue?vue&type=style&index=0&id=581fb096&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports